function syncCardHeights() {
  frame = null;

  document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
    const cards = getVisibleCards(section);

    // 1. Reset inline height variables on all cards to measure natural height
    cards.forEach((card) => {
      card.style.removeProperty(CARD_HEIGHT_PROPERTY);
      card.style.height = 'auto'; // allow natural flow during measurement
    });

    // 2. Measure natural content height for each card in a row
    groupCardsByRow(cards).forEach(({ cards: rowCards }) => {
      let maxHeight = 0;

      rowCards.forEach((card) => {
        // Clear manual height temporarily to derive true max-content
        const naturalHeight = Math.ceil(
          Math.max(card.getBoundingClientRect().height, card.scrollHeight)
        );
        if (naturalHeight > maxHeight) {
          maxHeight = naturalHeight;
        }
      });

      // 3. Apply calculated max content height to all cards in the row
      rowCards.forEach((card) => {
        card.style.removeProperty('height'); // cleanup temporary inline auto
        card.style.setProperty(CARD_HEIGHT_PROPERTY, `${maxHeight}px`);
      });
    });
  });
}